module.exports = __webpack_public_path__ + "assets/img/no-data.e335ae66.png";